import axiosInstance from "@/api/axiosInstance";

export async function cancelPaymentRequest(uuid: string): Promise<void> {
  await axiosInstance.post(`/api/private/payment-requests/${uuid}/cancel`);
}
